import { render, staticRenderFns } from "./PdfViewerDialog.vue?vue&type=template&id=07fa455b&"
import script from "./PdfViewerDialog.vue?vue&type=script&lang=ts&"
export * from "./PdfViewerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports